import { AnyAction } from '@reduxjs/toolkit';
import { difference, union } from 'lodash';

export const avatarOptions = [
	'assets/AvatarsPng/Avatar_2@3x.png',
	'assets/AvatarsPng/Avatar_3@3x.png',
	'assets/AvatarsPng/Avatar_4@3x.png',
	'assets/AvatarsPng/Avatar_5@3x.png',
	'assets/AvatarsPng/Avatar_6@3x.png',
	'assets/AvatarsPng/Avatar_7@3x.png',
];

// Usual actions are CRUD
export const AVATAR_UPDATE = 'profile/update';

export type AvatarPayload = {
	avatar: string;
};

export type AvatarReducerAction = {
	type: string;
	payload: AvatarPayload;
};

const initialState: AvatarPayload = {
	avatar: avatarOptions[Math.floor(Math.random() * avatarOptions.length)],
};

export default function avatarReducer(state = initialState, action: AnyAction) {
	let new_state = Object.assign({}, state) as AvatarPayload;

	switch (action.type) {
		case AVATAR_UPDATE: {
			new_state.avatar = action.payload.avatar;
			return new_state;
		}
		default:
			return state;
	}
}
